export default __webpack_public_path__ + "static/media/top20dark.9c7e069f.svg";